'use client';

import React, { useEffect } from 'react';
import { useTrack } from '@chewy/use-analytics';
import { navigateToLink } from '@/utils/helpCenterUtils';
import { useRouter } from 'next/navigation';
import LinksPanel, { LinkData } from '@/components/helpCenter/common/linksPanel';
import isEmpty from 'lodash/isEmpty';

export interface ExploreMorePanelProps {
  readonly title?: string | null;
  readonly linksData?: LinkData[] | null;
}

const ExploreMorePanel: React.FC<ExploreMorePanelProps> = ({ title, linksData = [] }) => {
  const router = useRouter();
  const track = useTrack();

  const hasTrackedView = React.useRef(false);

  useEffect(() => {
    if (isEmpty(linksData) || hasTrackedView.current) {
      return;
    }

    hasTrackedView.current = true;

    track('Explore More Panel Viewed', {
      id: 'explore-more-panel-viewed-id',
      parentId: 'explore-more-panel-id',
      level: 'explore-more-panel',
      type: 'static',
      position: 1,
      event_name: 'Widget Viewed',
      eventAction: 'impression',
      eventCategory: 'help-center',
      eventLabel: 'help-center-explore-chewy-view',
      name: 'Explore More Panel Viewed'
    });
  }, [linksData, track]);

  const handleClick = (linkData: LinkData) => {
    track('Explore More Panel Link Clicked', {
      id: 'explore-more-panel-link-clicked-id',
      parentId: 'explore-more-panel-id',
      level: 'explore-more-panel',
      type: 'static',
      position: 1,
      event_name: 'Link Clicked',
      eventAction: 'click',
      eventCategory: 'help-center',
      eventLabel: 'help-center-explore-chewy-click',
      name: 'Explore More Panel Link Clicked',
      linkId: linkData?.id,
      linkTitle: linkData?.title,
      linkCategoryId: linkData?.categoryId,
      linkSectionId: linkData?.sectionId,
      linkSectionTitle: linkData?.sectionTitle,
      linkSectionCategoryId: linkData?.sectionCategoryId
    });

    navigateToLink(linkData?.link, router);
  };

  return !isEmpty(linksData) ? <LinksPanel linksData={linksData} title={title} handleClick={handleClick} /> : null;
};

export default ExploreMorePanel;
